import { CollectionType, PreferenceType } from '@sas/nova-core/internal';
import { getPreferences, setPreferences } from '@sas/nova-core/services/preferences';
import { RequestParamLimit } from '../../../../../sonder/rest/paging';
import { SavedSearchResponse } from '../../../../grpc_web_catalog/catalog.pb';
import { GO_MAX_INT32 } from '../../catalog/access/catalogServiceAccessorREST';

// PreferenceKeySearchesFree is the key for catalog's saved searches
const PreferenceKeySearchesFree = 'SASInformationCatalog.searches.free';

// GetPreviousSearches - get all previous searches from preferences
export const GetPreviousSearches = async (): Promise<Array<SavedSearchResponse> | null> => {
  const allUserPreferences = await getPreferences({
    params: { [RequestParamLimit]: GO_MAX_INT32 },
  });
  const savedSearchPref = filterUserPrefs(allUserPreferences, PreferenceKeySearchesFree);

  if (savedSearchPref) {
    return JSON.parse(savedSearchPref) as Array<SavedSearchResponse>;
  }

  return null;
};

export const SetPreviousSearches = async (
  searches: Array<SavedSearchResponse>
): Promise<Array<SavedSearchResponse> | null> => {
  const userPreferences = await setPreferences([
    { id: PreferenceKeySearchesFree, value: JSON.stringify(searches) },
  ]);
  const updatedPreferenceValue = filterUserPrefs(userPreferences, PreferenceKeySearchesFree);
  if (updatedPreferenceValue) {
    return JSON.parse(updatedPreferenceValue) as Array<SavedSearchResponse>;
  }

  return null;
};

const filterUserPrefs = (userPreferences: CollectionType<PreferenceType>, key: string) => {
  let matchingPreference;
  for (const userPref of userPreferences.items) {
    if (userPref.id === key) {
      matchingPreference = userPref.value;
      break;
    }
  }
  return matchingPreference;
};
